module.exports = __webpack_public_path__ + "img/DSC_0091.06c336f9.jpg";